import { Alert, Box, Skeleton, Typography } from "@mui/material";
import MoedaText from "../../../util/ui/inputs/moedaText";
import { radius } from "../../../../theme";
import { TotalPorMoeda } from "../totaisCustodia";

type Props = {
  valorTotalCustodia: number;
  // Custo de aquisição na moeda de origem, sem conversão (um por moeda)
  totaisPorMoeda?: TotalPorMoeda[];
  loading?: boolean;
};

export default function CustodiaInternacionalCompacta({
  valorTotalCustodia,
  totaisPorMoeda = [],
  loading = false,
}: Props) {
  return (
    // Painel de destaque por hairline, não por borda grossa colorida.
    <Alert
      sx={{
        height: "100%",
        bgcolor: "background.paper",
        borderColor: "divider",
        color: "text.primary",
        borderRadius: `${radius.xxl}px`,
      }}
      variant="outlined"
      severity="info"
      icon={false}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
        flexGrow={1}
      >
        <Typography
          color="text.primary"
          sx={{
            fontVariantNumeric: "tabular-nums",
            fontWeight: 600,
            fontSize: 20,
            letterSpacing: "-0.01em",
          }}
        >
          {loading ? (
            <Skeleton variant="text" width={180} animation={false} />
          ) : (
            <MoedaText value={valorTotalCustodia} />
          )}
        </Typography>
        {!loading &&
          totaisPorMoeda.map((t) => (
            <Typography
              key={t.moeda}
              variant="dataMono"
              color="text.secondary"
              sx={{ fontSize: 13 }}
            >
              <MoedaText value={t.valorOriginal} prefix={`${t.moeda} `} />
            </Typography>
          ))}
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Typography sx={{ fontSize: 16 }}>🌎</Typography>
          <Typography variant="labelMono" color="text.secondary">
            Custódia Internacional
          </Typography>
        </Box>
      </Box>
    </Alert>
  );
}
